// @flow
import React, { type Node, useMemo } from 'react';
import moment from 'moment-timezone';

import SimpleDate from 'app/dataProviders/SimpleDate';

import ScheduleDay from './ScheduleDay';
import fillWeekFromDay from './fillWeekFromDay';
import useScheduleWeekData from './useScheduleWeekData';
import { MarksThemeProvider } from '../MarkList';
import styles from './DnevnikContent.scss';


const daysSchema = [[0, 1, 2], [3, 4, 5]];

type Props = {
  day: SimpleDate,
  studentId: string,
  klassId: string,
}

const DnevnikContent = ({ day, studentId, klassId }: Props): Node => {
  const [data, loading] = useScheduleWeekData({ date: day, studentId, klassId });

  const dayTitles = useMemo(() => {
    return fillWeekFromDay(day, 'DD MMMM');
  }, [day]);

  const weekDays: Array<string> = useMemo(() => {
    return moment.weekdaysShort(true).map(s => `${s[0].toUpperCase()}${s[1]}`);
  }, []);

  return (
    <MarksThemeProvider>
      <table className={styles.table}>
        <tbody>
          <tr>
            {daysSchema.map((columns, i) => (
              <td className={styles.column} key={i}>
                {columns.map(dayIndex => (
                  <ScheduleDay
                    key={dayIndex}
                    title={dayTitles[dayIndex]}
                    weekDay={weekDays[dayIndex]}
                    loading={loading}
                    data={data[dayIndex] || null}
                    studentId={studentId}
                  />
                ))}
              </td>
            ))}
          </tr>
        </tbody>
      </table>
    </MarksThemeProvider>
  );
};

export default DnevnikContent;
